<template>
  <b-modal
    id="create-customer-modal"
    centered
    hide-footer
    title="Create Customer"
  >

    <b-form-group label="First Name">
      <b-form-input v-model="first_name" />
    </b-form-group>

    <b-form-group label="Last Name">
      <b-form-input v-model="last_name" />
    </b-form-group>

    <b-form-group label="Phone">
      <b-form-input v-model="phone" />
    </b-form-group>

    <b-form-group label="Email">
      <b-form-input v-model="email" />
    </b-form-group>

    <b-form-group label="State">
      <b-form-select
        v-model="state"
        :options="stateOptions"
      />
    </b-form-group>

    <div class="text-right">
      <b-button variant="primary" @click="submit">
        Create
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      state: null,
      stateOptions: [],
    };
  },

  async mounted() {
    await this.fetchStates();
  },

  methods: {
    ...mapActions("appData", [
      "createCustomer",
      "getStates",
    ]),

    async fetchStates() {
      const res = await this.getStates();
      const list = (res.data && res.data.results) ? res.data.results : (Array.isArray(res.data) ? res.data : []);
      this.stateOptions = [
        { value: null, text: "Select state..." },
        ...list.map(s => ({ value: s.id, text: s.name }))
      ];
    },

    async submit() {
      await this.createCustomer({
        first_name: this.first_name,
        last_name: this.last_name,
        phone: this.phone,
        email: this.email,
        state: this.state,
      });

      this.$bvModal.hide("create-customer-modal");
      this.$emit("modalClosed");
    },
  },
};
</script>